import React from 'react';
import { Link } from 'react-router-dom';
import { IRouteLink } from 'modules/navbar/routes';

export const MobileNavigationDropdownLink = (props: IRouteLink) => (
    <li>
        <Link to={props.to}>{props.text}</Link>
    </li>
);
